// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Theme from "../../styles/Theme.bs.js";
import * as React from "react";
import * as Emotion from "../../bindings/Emotion.bs.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as JsxRuntime from "react/jsx-runtime";

function ArticleMeta$ArticleMeta(props) {
  let __className = props.className;
  let className = __className !== undefined ? __className : "";
  let parts = Stdlib_Array.keepSome([
    props.author,
    props.date,
    props.location
  ]);
  if (parts.length === 0) {
    return null;
  } else {
    return JsxRuntime.jsx("div", {
      children: parts.map((part, index) => JsxRuntime.jsxs(React.Fragment, {
        children: [
          index > 0 ? JsxRuntime.jsx("span", {
              children: "·",
              "aria-hidden": true
            }) : null,
          JsxRuntime.jsx("span", {
            children: part
          })
        ]
      }, part + index.toString())),
      className: Emotion.Css.cx([
        Emotion.Css.css({
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: "0.75rem",
          marginBottom: "1.5rem",
          paddingBottom: "1.5rem",
          borderBottom: `1px solid ` + Emotion.Utils.Color.border,
          fontFamily: Theme.Theme.Typography.fontFamily.sans,
          fontSize: "0.8125rem",
          letterSpacing: "0.06em",
          textTransform: "uppercase",
          color: Emotion.Utils.Color.textSecondary
        }),
        className
      ])
    });
  }
}

let ArticleMeta = {
  make: ArticleMeta$ArticleMeta
};

export {
  ArticleMeta,
}
/* Theme Not a pure module */
